<template>
  <div>
    <b-dropdown id="time-period-options" toggle-tag="div" toggle-class="p-0 bg-transparent">
      <template #button-content>
        <McButton
          variant="secondary"
          icon="icon-outline_chevron-down"
          icon-position="right"
          :text="selectedPeriodLabel"
        />
      </template>

      <b-dropdown-item
        v-for="option in typeOptions"
        @click="handleUpdatePeriod(option.value)"
        :key="option.value"
      >
        <div class="d-flex justify-content-between align-items-center">
          <span>{{ option.label }}</span>
          <i class="icon-fill_checkmark-circle icon-success" v-if="option.value === type"></i>
        </div>
      </b-dropdown-item>
    </b-dropdown>
  </div>
</template>

<script>
import McButton from '@/components/McButton'

export default {
  components: {
    McButton,
  },
  props: {
    type: {
      type: String,
    },
  },
  data() {
    return {}
  },
  computed: {
    typeOptions() {
      return [
        { label: this.$t('fleetAvailability.action.hourly'), value: 'hour' },
        { label: this.$t('fleetAvailability.action.daily'), value: 'day' },
      ]
    },
    selectedPeriodLabel() {
      return this.typeOptions.find((type) => type.value === this.type).label
    },
  },
  methods: {
    handleUpdatePeriod(newPeriod) {
      this.$emit('update:type', newPeriod)
    },
  },
}
</script>

<style scoped lang="scss">
:deep(.btn-secondary) {
  &:hover,
  &:focus,
  &:active {
    opacity: 1;
  }

  border: none;
}

.icon-success {
  font-size: 14px;

  &:before {
    color: $success;
  }
}
</style>
